<!-- 地图 -->
<style lang="stylus" scoped>
.describe {
  color: #fff;

  .title {
    font-size: 3.6vh;
    text-align: center;
  }

  .total-num {
    font-size: 7.5vh;
    margin: 3vh auto;
    display: flex;
    justify-content: center;

    .num {
      background: url('../../../../../assets/img/trace/bg-num.png');
      background-size: 100% 100%;
      width: 8.4vh;
      height: 10.6vh;
      line-height: 10.6vh;
      text-align: center;
      margin-right: 1.6vh;
    }
  }
}

.center {
  height: 48vh;
  padding: 0.5vh;
  margin-top: 2.5vh;

  .map {
    width: 100%;
    height: 56vh;
    margin: 0 auto;
    background: url('../../../../../assets/img/dashboard/map.png');
    background-size: 100% 100%;

    .name {
      font-size: 2.4vh;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      line-height: 1.3vh;
      padding-top: 3vh;

      &:before {
        display: block;
        content: '';
        width: 0.8vh;
        height: 2.4vh;
        background: #FFF;
        float: left;
        margin-top: -0.5vh;
        margin-left: 3vh;
        margin-right: 1vh;
        background-size: 100% 100%;
      }
    }

    .table {
      height: 56vh;
      margin: 0 auto;
      color: #fff;
      text-align: center;
      overflow: hidden;

      .line {
        height: 56vh;
        margin-top:-3vh;

        .main {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>

<template>
  <div>
    <div class="center">
      <div class="describe">
        <p class="title">可追溯商品总量</p>
        <div class="total-num">
          <div class="num" v-for="(item, index) in data" :key="index">{{ item }}</div>
        </div>
      </div>
      <div class="map">
        <div class="name">扫码区域</div>
        <div class="table">
          <div class="line">
            <div class="main"></div>
          </div>
          <!-- <flow></flow> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import VueAMap from 'vue-amap';
import echarts from 'echarts'
import china from 'echarts/map/js/china'
import flow from './flow'
import MapLoader from './map.js'

Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
  key: '12fea8c7f7f0ec1a0a851b89feaf84ea',
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Geocoder', 'AMap.Geolocation', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor', 'AMap.MouseTool'],
  uiVersion: '1.0.11'
});
// var geoCoordMap = {
//   // '上海市': [121.473701, 31.230416],
//   // '北京市': [116.407526, 39.90403],
//   // '南京市': [118.796877, 32.060255],
//   // '常州市': [119.973987, 31.810689],
//   // '广州市': [113.264434, 23.129162],
//   '杭州市': [120.15507, 30.274084],
//   '浙江省杭州市': [120.15507, 30.274084],
//   // '西安市': [108.940174, 34.341568],
//   // '长沙市': [112.938814, 28.228209],
//   "陵水": [110.0439879098, 18.5123869278]
// }

var geoCoordMap = {
  "陵水": [110.0439879098, 18.5123869278],
  '七台河市': ["131.003138", "45.771726"],
  '三亚市': ["109.511909", "18.252847"],
  '三明市': ["117.638678", "26.263406"],
  '三沙市': ["112.338695", "16.831839"],
  '三门峡市': ["111.200135", "34.772493"],
  '上海市': ["121.473701", "31.230416"],
  '上饶市': ["117.943433", "28.454863"],
  '东莞市': ["113.751765", "23.020536"],
  '东营市': ["118.674767", "37.434751"],
  '中卫市': ["105.196902", "37.499972"],
  '中山市': ["113.392782", "22.517645"],
  '临夏回族自治州': ["103.210538", "35.601182"],
  '临汾市': ["111.518976", "36.088005"],
  '临沂市': ["118.356448", "35.104672"],
  '临沧市': ["100.079583", "23.877573"],
  '丹东市': ["124.354706", "40.000499"],
  '丽水市': ["119.922796", "28.467630"],
  '丽江市': ["100.227750", "26.855047"],
  '乌兰察布市': ["113.132585", "40.994785"],
  '乌海市': ["106.794249", "39.655388"],
  '乌鲁木齐市': ["87.616848", "43.825592"],
  '乐山市': ["103.765568", "29.552106"],
  '九江市': ["116.001930", "29.705077"],
  '云南省': ["102.710002", "25.045806"],
  '云浮市': ["112.044491", "22.915094"],
  '亳州市': ["115.778676", "33.844582"],
  '伊春市': ["128.841147", "47.727536"],
  '伊犁哈萨克自治州': ["81.324136", "43.916823"],
  '佛山市': ["113.121416", "23.021548"],
  '佳木斯市': ["130.318917", "46.799922"],
  '保定市': ["115.464806", "38.873891"],
  '保山市': ["99.161761", "25.112046"],
  '信阳市': ["114.091023", "32.146983"],
  '儋州市': ["109.580811", "19.521134"],
  '克孜勒苏柯尔克孜自治州': ["76.167819", "39.714526"],
  '克拉玛依市': ["84.889207", "45.579888"],
  '六安市': ["116.521854", "31.733699"],
  '六盘水市': ["104.830359", "26.592666"],
  '兰州市': ["103.834303", "36.061089"],
  '兴安盟': ["122.067042", "46.077561"],
  '内江市': ["105.058433", "29.580228"],
  '内蒙古自治区': ["111.765617", "40.817498"],
  '凉山彝族自治州': ["102.267335", "27.881610"],
  '包头市': ["109.840347", "40.657449"],
  '北京市': ["116.407526", "39.904030"],
  '北海市': ["109.119927", "21.481254"],
  '十堰市': ["110.797990", "32.629397"],
  '南京市': ["118.796877", "32.060255"],
  '南充市': ["106.110698", "30.837793"],
  '南宁市': ["108.366543", "22.817002"],
  '南平市': ["118.177708", "26.641768"],
  '南昌市': ["115.858197", "28.682892"],
  '南通市': ["120.894291", "31.980171"],
  '南阳市': ["112.528321", "32.990833"],
  '博尔塔拉蒙古自治州': ["82.066159", "44.905588"],
  '厦门市': ["118.089425", "24.479833"],
  '双鸭山市': ["131.159133", "46.646508"],
  '台州市': ["121.420757", "28.656386"],
  '台湾省': ["121.508903", "25.044319"],
  '合肥市': ["117.227239", "31.820586"],
  '吉安市': ["114.992509", "27.113443"],
  '吉林市': ["126.549576", "43.837883"],
  '吉林省': ["125.325990", "43.896536"],
  '吐鲁番市': ["89.189651", "42.951382"],
  '吕梁市': ["111.144319", "37.518314"],
  '吴忠市': ["106.198393", "37.997460"],
  '周口市': ["114.696951", "33.626149"],
  '呼伦贝尔市': ["119.765744", "49.211574"],
  '呼和浩特市': ["111.749180", "40.842585"],
  '和田地区': ["79.922211", "37.114157"],
  '咸宁市': ["114.322492", "29.841443"],
  '咸阳市': ["108.708991", "34.329605"],
  '哈密市': ["93.514916", "42.818501"],
  '哈尔滨市': ["126.534967", "45.803775"],
  '唐山市': ["118.180193", "39.630867"],
  '商丘市': ["115.656370", "34.414172"],
  '商洛市': ["109.940477", "33.870422"],
  '喀什地区': ["75.989755", "39.470400"],
  '嘉兴市': ["120.755486", "30.746129"],
  '嘉峪关市': ["98.289152", "39.773130"],
  '四川省': ["104.075931", "30.651651"],
  '四平市': ["124.350398", "43.166419"],
  '固原市': ["106.242610", "36.015855"],
  '塔城地区': ["82.980316", "46.745364"],
  '大兴安岭地区': ["124.711080", "52.335206"],
  '大同市': ["113.300129", "40.076762"],
  '大庆市': ["125.103784", "46.589309"],
  '大理白族自治州': ["100.267638", "25.606486"],
  '大连市': ["121.614682", "38.914003"],
  '天水市': ["105.724947", "34.580863"],
  '天津市': ["117.200983", "39.084158"],
  '太原市': ["112.548879", "37.870590"],
  '威海市': ["122.120419", "37.513068"],
  '娄底市': ["111.993497", "27.700062"],
  '孝感市': ["113.916902", "30.924568"],
  '宁夏回族自治区': ["106.258754", "38.471317"],
  '宁德市': ["119.547932", "26.665617"],
  '宁波市': ["121.550357", "29.874556"],
  '安庆市': ["117.063754", "30.543494"],
  '安康市': ["109.029022", "32.684714"],
  '安徽省': ["117.284922", "31.861184"],
  '安阳市': ["114.392392", "36.097577"],
  '安顺市': ["105.947593", "26.253072"],
  '定西市': ["104.626282", "35.580662"],
  '宜宾市': ["104.643215", "28.751768"],
  '宜昌市': ["111.286471", "30.691967"],
  '宜春市': ["114.416778", "27.815619"],
  '宝鸡市': ["107.237974", "34.361979"],
  '宣城市': ["118.758816", "30.940718"],
  '宿州市': ["116.964356", "33.646373"],
  '宿迁市': ["118.275198", "33.963232"],
  '山东省': ["117.020359", "36.668530"],
  '山南市': ["91.773134", "29.237137"],
  '山西省': ["112.562398", "37.873531"],
  '岳阳市': ["113.128958", "29.357104"],
  '崇左市': ["107.364711", "22.376532"],
  '巴中市': ["106.747477", "31.867903"],
  '巴彦淖尔市': ["107.387657", "40.743213"],
  '巴音郭楞蒙古自治州': ["86.145298", "41.764115"],
  '常州市': ["119.973987", "31.810689"],
  '常德市': ["111.698497", "29.031673"],
  '平凉市': ["106.665240", "35.543051"],
  '平顶山市': ["113.192661", "33.766169"],
  '广东省': ["113.266530", "23.132191"],
  '广元市': ["105.843357", "32.435435"],
  '广安市': ["106.633212", "30.455961"],
  '广州市': ["113.264434", "23.129162"],
  '广西壮族自治区': ["108.327546", "22.815478"],
  '庆阳市': ["107.643631", "35.709077"],
  '廊坊市': ["116.683752", "39.538047"],
  '延安市': ["109.489727", "36.585455"],
  '延边朝鲜族自治州': ["129.508946", "42.891253"],
  '开封市': ["114.307581", "34.797239"],
  '张家口市': ["114.887543", "40.824418"],
  '张家界市': ["110.479191", "29.117096"],
  '张掖市': ["100.449818", "38.925875"],
  '徐州市': ["117.284124", "34.205768"],
  '德宏傣族景颇族自治州': ["98.584895", "24.433353"],
  '德州市': ["116.357464", "37.434092"],
  '德阳市': ["104.397894", "31.126855"],
  '忻州市': ["112.734174", "38.416663"],
  '怀化市': ["109.998488", "27.554978"],
  '怒江傈僳族自治州': ["98.853097", "25.852547"],
  '恩施土家族苗族自治州': ["109.488172", "30.272156"],
  '惠州市': ["114.416196", "23.111847"],
  '成都市': ["104.066541", "30.572269"],
  '扬州市': ["119.412966", "32.394210"],
  '承德市': ["117.962410", "40.954071"],
  '抚州市': ["116.358181", "27.949217"],
  '抚顺市': ["123.957208", "41.880872"],
  '拉萨市': ["91.140856", "29.645554"],
  '揭阳市': ["116.372831", "23.549993"],
  '攀枝花市': ["101.718637", "26.582347"],
  '文山壮族苗族自治州': ["104.216248", "23.400733"],
  '新乡市': ["113.926800", "35.303004"],
  '新余市': ["114.917346", "27.817808"],
  '新疆维吾尔自治区': ["87.627704", "43.793026"],
  '无锡市': ["120.311910", "31.491169"],
  '日喀则市': ["88.880583", "29.266869"],
  '日照市': ["119.526888", "35.416377"],
  '昆明市': ["102.832891", "24.880095"],
  '昌吉回族自治州': ["87.308224", "44.011182"],
  '昌都市': ["97.172020", "31.140969"],
  '昭通市': ["103.717465", "27.338257"],
  '晋中市': ["112.752694", "37.687024"],
  '晋城市': ["112.851831", "35.490701"],
  '普洱市': ["100.966512", "22.825065"],
  '景德镇市': ["117.178419", "29.268835"],
  '曲靖市': ["103.796167", "25.489999"],
  '朔州市': ["112.432825", "39.331595"],
  '朝阳市': ["120.450372", "41.573734"],
  '本溪市': ["123.766485", "41.294175"],
  '来宾市': ["109.221465", "23.750306"],
  '杭州市': ["120.155070", "30.274084"],
  '松原市': ["124.825117", "45.141789"],
  '林芝市': ["94.361558", "29.648943"],
  '果洛藏族自治州': ["100.244808", "34.471431"],
  '枣庄市': ["117.323725", "34.810487"],
  '柳州市': ["109.415953", "24.325502"],
  '株洲市': ["113.134002", "27.827550"],
  '桂林市': ["110.290194", "25.273566"],
  '梅州市': ["116.122238", "24.288615"],
  '梧州市': ["111.279115", "23.476962"],
  '楚雄彝族自治州': ["101.528068", "25.045532"],
  '榆林市': ["109.734589", "38.285390"],
  '武威市': ["102.638011", "37.928264"],
  '武汉市': ["114.305392", "30.593098"],
  '毕节市': ["105.283992", "27.302589"],
  '永州市': ["111.613445", "26.420394"],
  '汉中市': ["107.023323", "33.067480"],
  '汕头市': ["116.681972", "23.354091"],
  '汕尾市': ["115.375278", "22.786211"],
  '江苏省': ["118.763232", "32.061707"],
  '江西省': ["115.909228", "28.675696"],
  '江门市': ["113.081901", "22.578738"],
  '池州市': ["117.491568", "30.664800"],
  '沈阳市': ["123.431474", "41.805698"],
  '沧州市': ["116.838834", "38.304477"],
  '河北省': ["114.468664", "38.037057"],
  '河南省': ["113.753602", "34.765515"],
  '河池市': ["108.085261", "24.692931"],
  '河源市': ["114.700447", "23.743538"],
  '泉州市': ["118.675675", "24.874132"],
  '泰安市': ["117.087614", "36.200252"],
  '泰州市': ["119.923116", "32.455778"],
  '泸州市': ["105.442258", "28.871811"],
  '洛阳市': ["112.454040", "34.619682"],
  '济南市': ["117.119999", "36.651216"],
  '济宁市': ["116.587098", "35.414921"],
  '浙江省': ["120.152791", "30.267446"],
  '海东市': ["102.104287", "36.502039"],
  '海北藏族自治州': ["100.900997", "36.954413"],
  '海南省': ["110.349228", "20.017377"],
  '海南藏族自治州': ["100.620373", "36.286437"],
  '海口市': ["110.198293", "20.044001"],
  '海西蒙古族藏族自治州': ["97.369751", "37.377139"],
  '淄博市': ["118.054927", "36.813487"],
  '淮北市': ["116.798265", "33.955844"],
  '淮南市': ["116.999932", "32.625478"],
  '淮安市': ["119.015285", "33.610353"],
  '深圳市': ["114.057868", "22.543099"],
  '清远市': ["113.056031", "23.681763"],
  '温州市': ["120.699366", "27.994267"],
  '渭南市': ["109.509786", "34.499995"],
  '湖北省': ["114.341861", "30.546498"],
  '湖南省': ["112.983810", "28.112444"],
  '湖州市': ["120.086823", "30.894348"],
  '湘潭市': ["112.944049", "27.829738"],
  '湘西土家族苗族自治州': ["109.739172", "28.311947"],
  '湛江市': ["110.359377", "21.270707"],
  '滁州市': ["118.317106", "32.301556"],
  '滨州市': ["117.970703", "37.381990"],
  '漯河市': ["114.016539", "33.581412"],
  '漳州市': ["117.647481", "24.512948"],
  '潍坊市': ["119.161755", "36.706774"],
  '潮州市': ["116.622603", "23.656950"],
  '澳门特别行政区': ["113.543028", "22.186835"],
  '濮阳市': ["115.029215", "35.761829"],
  '烟台市': ["121.447935", "37.463822"],
  '焦作市': ["113.241823", "35.215892"],
  '牡丹江市': ["129.633168", "44.551653"],
  '玉林市': ["110.164756", "22.636379"],
  '玉树藏族自治州': ["97.091934", "33.011674"],
  '玉溪市': ["102.546543", "24.352036"],
  '珠海市': ["113.576726", "22.270715"],
  '甘南藏族自治州': ["102.911027", "34.983385"],
  '甘孜藏族自治州': ["101.962310", "30.049520"],
  '甘肃省': ["103.826308", "36.059421"],
  '白城市': ["122.839024", "45.619641"],
  '白山市': ["126.423587", "41.939994"],
  '白银市': ["104.138559", "36.544756"],
  '百色市': ["106.618201", "23.902333"],
  '益阳市': ["112.355180", "28.553860"],
  '盐城市': ["120.163561", "33.347382"],
  '盘锦市': ["122.070714", "41.119997"],
  '眉山市': ["103.848538", "30.075439"],
  '石嘴山市': ["106.383303", "38.983236"],
  '石家庄市': ["114.514859", "38.042306"],
  '福州市': ["119.296494", "26.074507"],
  '福建省': ["119.295144", "26.100779"],
  '秦皇岛市': ["119.600492", "39.935385"],
  '红河哈尼族彝族自治州': ["103.374799", "23.363130"],
  '绍兴市': ["120.580232", "30.029752"],
  '绥化市': ["126.968887", "46.653845"],
  '绵阳市': ["104.679114", "31.467450"],
  '聊城市': ["115.985371", "36.456703"],
  '肇庆市': ["112.465091", "23.047191"],
  '自贡市': ["104.778442", "29.339030"],
  '舟山市': ["122.207215", "29.985295"],
  '芜湖市': ["118.432941", "31.352859"],
  '苏州市': ["120.585315", "31.298886"],
  '茂名市': ["110.925456", "21.662999"],
  '荆州市': ["112.239741", "30.335165"],
  '荆门市': ["112.199265", "31.035423"],
  '莆田市': ["119.007777", "25.454084"],
  '莱芜市': ["117.676723", "36.213813"],
  '菏泽市': ["115.480656", "35.233750"],
  '萍乡市': ["113.854556", "27.622768"],
  '营口市': ["122.235417", "40.667012"],
  '葫芦岛市': ["120.836932", "40.711052"],
  '蚌埠市': ["117.389719", "32.916287"],
  '衡水市': ["115.670177", "37.738920"],
  '衡阳市': ["112.571997", "26.893230"],
  '衢州市': ["118.859457", "28.970079"],
  '襄阳市': ["112.122414", "32.008986"],
  '西双版纳傣族自治州': ["100.797777", "22.007351"],
  '西宁市': ["101.778228", "36.617144"],
  '西安市': ["108.940174", "34.341568"],
  '西藏自治区': ["91.117212", "29.646922"],
  '许昌市': ["113.852640", "34.035506"],
  '贵州省': ["106.707410", "26.598194"],
  '贵港市': ["109.598926", "23.111530"],
  '贵阳市': ["106.630153", "26.647661"],
  '贺州市': ["111.566694", "24.403582"],
  '资阳市': ["104.627636", "30.128901"],
  '赣州市': ["114.935029", "25.831829"],
  '赤峰市': ["118.886856", "42.257817"],
  '辽宁省': ["123.429440", "41.835441"],
  '辽源市': ["125.143532", "42.887918"],
  '辽阳市': ["123.236944", "41.267244"],
  '达州市': ["107.468023", "31.209571"],
  '运城市': ["111.007528", "35.026412"],
  '连云港市': ["119.221611", "34.596653"],
  '迪庆藏族自治州': ["99.702234", "27.818882"],
  '通化市': ["125.939697", "41.728401"],
  '通辽市': ["122.243444", "43.652890"],
  '遂宁市': ["105.592898", "30.532847"],
  '遵义市': ["106.927389", "27.725654"],
  '邢台市': ["114.504844", "37.070589"],
  '那曲地区': ["92.051239", "31.476202"],
  '邯郸市': ["114.538961", "36.625657"],
  '邵阳市': ["111.467791", "27.238892"],
  '郑州市': ["113.625368", "34.746599"],
  '郴州市': ["113.014717", "25.770509"],
  '鄂尔多斯市': ["109.781327", "39.608266"],
  '鄂州市': ["114.894843", "30.391940"],
  '酒泉市': ["98.494483", "39.732410"],
  '重庆市': ["106.551556", "29.563009"],
  '金华市': ["119.647444", "29.079059"],
  '金昌市': ["102.188043", "38.520089"],
  '钦州市': ["108.654146", "21.979933"],
  '铁岭市': ["123.726166", "42.223769"],
  '铜仁市': ["109.189598", "27.731514"],
  '铜川市': ["108.945233", "34.896756"],
  '铜陵市': ["117.812079", "30.945429"],
  '银川市': ["106.230909", "38.487193"],
  '锡林郭勒盟': ["116.048222", "43.933454"],
  '锦州市': ["121.127003", "41.095119"],
  '镇江市': ["119.425836", "32.187849"],
  '长春市': ["125.323544", "43.817071"],
  '长沙市': ["112.938814", "28.228209"],
  '长治市': ["113.116255", "36.195386"],
  '阜新市': ["121.670323", "42.021619"],
  '阜阳市': ["115.814204", "32.890124"],
  '防城港市': ["108.353846", "21.686860"],
  '阳江市': ["111.982232", "21.857958"],
  '阳泉市': ["113.580519", "37.856971"],
  '阿克苏地区': ["80.260605", "41.168779"],
  '阿勒泰地区': ["88.141253", "47.844924"],
  '阿坝藏族羌族自治州': ["102.224653", "31.899413"],
  '阿拉善盟': ["105.728969", "38.851892"],
  '阿里地区': ["80.105804", "32.501111"],
  '陇南市': ["104.921841", "33.400684"],
  '陕西省': ["108.954239", "34.265472"],
  '随州市': ["113.382458", "31.690215"],
  '雅安市': ["103.013261", "29.980537"],
  '青岛市': ["120.382639", "36.067082"],
  '青海省': ["101.780199", "36.620901"],
  '鞍山市': ["122.994329", "41.108647"],
  '韶关市': ["113.597522", "24.810403"],
  '香港特别行政区': ["114.163825", "22.276284"],
  '马鞍山市': ["118.506759", "31.670452"],
  '驻马店市': ["114.022298", "33.011529"],
  '鸡西市': ["130.969333", "45.295075"],
  '鹤壁市': ["114.297272", "35.747225"],
  '鹤岗市': ["130.297964", "47.349916"],
  '鹰潭市': ["117.069202", "28.260189"],
  '黄冈市': ["114.872316", "30.453905"],
  '黄南藏族自治州': ["102.015248", "35.519548"],
  '黄山市': ["118.337481", "29.714655"],
  '黄石市': ["115.038520", "30.199652"],
  '黑河市': ["127.528560", "50.245329"],
  '黑龙江省': ["126.661669", "45.742347"],
  '黔东南苗族侗族自治州': ["107.982859", "26.583442"],
  '黔南布依族苗族自治州': ["107.522097", "26.254092"],
  '黔西南布依族苗族自治州': ["104.906396", "25.087825"],
  '齐齐哈尔市': ["123.918186", "47.354348"],
  '龙岩市': ["117.017536", "25.075123"]
}


var XNData = [
  // [{ name: '陵水' }, { name: '长沙市', value: 35252 }],
  // [{ name: '陵水' }, { name: '西安市', value: 32674 }]
];

const planePath = 'arrow';

const convertData = function (data) {
  const res = [];
  for (let i = 0; i < data.length; i++) {
    const dataItem = data[i];

    const fromCoord = geoCoordMap[dataItem[0].name];
    const toCoord = geoCoordMap[dataItem[1].name];
    if (fromCoord && toCoord) {
      res.push({
        fromName: dataItem[0].name,
        toName: dataItem[1].name,
        coords: [fromCoord, toCoord],
        value: dataItem[1].value
      });
    }
  }
  return res;
};

const color = ['#a6c84c', '#ffa022', '#46bee9']; // 航线的颜色
const series = [];
export default {
  props: ["totalRelationCount", "cityStatisticsList"],
  data() {
    return {
      data: [],
      dataX: [],
      dataY: [],
      city: [],
      color: ['#AF69FF', '#00A0EA', '#13AF68', '#FFB52B', '#920784'],
      myChart: {},
      map: []
    }
  },
  components: {
    flow
  },
  methods: {
    show(XNData) {
      [['陵水', XNData]].forEach(function (item, i) {
        series.push({
          name: item[0] + ' Top3',
          type: 'lines',
          zlevel: 1,
          effect: {
            show: true,
            period: 6,
            trailLength: 0.7,
            color: 'red',   // arrow箭头的颜色
            symbolSize: 3
          },
          lineStyle: {
            normal: {
              color: color[i],
              width: 0,
              curveness: 0.2
            }
          },
          data: convertData(item[1])
        },
          {
            name: item[0] + ' Top3',
            type: 'lines',
            zlevel: 3,
            symbol: ['none', 'arrow'],
            symbolSize: 10,
            effect: {
              show: true,
              period: 6,
              trailLength: 0,
              symbol: planePath,
              symbolSize: 15
            },
            lineStyle: {
              normal: {
                color: color[i],
                width: 1,
                opacity: 0.6,
                curveness: 0.2
              }
            },
            data: convertData(item[1])
          },
          {
            name: item[0] + ' Top3',
            type: 'effectScatter',
            coordinateSystem: 'geo',
            zlevel: 2,
            rippleEffect: {
              brushType: 'stroke'
            },
            label: {
              normal: {
                show: true,
                position: 'right',
                formatter: '{b}'
              }
            },
            symbolSize: function (val) {
              return 10;
            },
            itemStyle: {
              normal: {
                color: color[i]
              },
              emphasis: {
                areaColor: '#2B91B7'
              }
            },
            data: item[1].map(function (dataItem) {
              return {
                name: dataItem[1].name,
                value: geoCoordMap[dataItem[1].name]
              };
            })
          },
          // 被攻击点
          {
            type: 'scatter',
            coordinateSystem: 'geo',
            zlevel: 2,
            rippleEffect: {
              period: 4,
              brushType: 'stroke',
              scale: 4
            },
            label: {
              normal: {
                show: true,
                position: 'right',
                color: '#0f0',
                formatter: '{b}',
                textStyle: {
                  color: "#0f0"
                }
              },
              emphasis: {
                show: true,
                color: "#f60"
              }
            },
            symbol: 'path://M512 39.384615l169.353846 295.384615 342.646154 63.015385-240.246154 248.123077L827.076923 984.615385l-315.076923-145.723077L196.923077 984.615385l43.323077-334.769231L0 401.723077l342.646154-63.015385L512 39.384615',
            symbolSize: 20,
            data: [{
              name: item[0],
              value: geoCoordMap[item[0]].concat([10])
            }]
          });
      });
    },
    resizeFunc() {
      this.myChart.resize()
    },
    getLatitude(regionCodeName) {
      return new Promise(resolve => {
        var geocoder
        AMap.plugin(['AMap.Geocoder'], function () {
          geocoder = new AMap.Geocoder({
            radius: 1000,
            extensions: 'all'
          });
          if (regionCodeName != null && regionCodeName !== undefined) {
            geocoder.getLocation(regionCodeName, function (status, result) {
              if (status === 'complete' && result.info === 'OK') {
                let longitude = result.geocodes[0].location.lng;
                let latitude = result.geocodes[0].location.lat;
                geoCoordMap[regionCodeName] = [longitude, latitude]
              } else {
                this.$message.error('获取经纬度失败');
              }
              resolve();
            });
          }
        })
      })
    },
    init() {
      const resizeFunc = this.resizeFunc;
      window.addEventListener('resize', resizeFunc)
    },
    getData() {
      this.myChart = echarts.int(document.querySelector(".line .main"));
      this.myChart.clear()
      this.chart();
    },
    chart() {
      // 基于准备好的dom，初始化echarts实例
      this.myChart = echarts.init(document.querySelector(".line .main"));
      this.myChart.setOption({
        tooltip: {
          show: false
        },
        geo: {
          map: 'china',
          roam: true,
          zoom: 1.2,
          aspectScale: 0.8,
          itemStyle: {
            normal: {
              areaColor: '#3A64C8',
              borderColor: '#195BB9',
              borderWidth: 1
            },
            emphasis: {
              areaColor: '#2B91B7'
            }
          }
        },
        series: series
      })
      this.init();
    }
  },
  destroyed() {
    const resizeFunc = this.resizeFunc;
    window.removeEventListener('resize', resizeFunc);
  },
  async mounted() {
    this.city = this.cityStatisticsList
    XNData = []
    Promise.all(this.city.map(async cityItem => {
      for (var key in geoCoordMap) {
        if (cityItem.province.replace("省", "").indexOf(key) > -1) {
          XNData.push([{ name: '陵水' }, { name: key, value: cityItem.scanCount }]);
        }
      }

      // await this.getLatitude(cityItem.province);
    }))
    console.log(XNData)
    this.show(XNData);
    this.chart();
    this.data = this.totalRelationCount.toString().split('')
  }
}
</script>




// WEBPACK FOOTER //
// index.vue?56d6d7f5